import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import * as Utils from "../utils/Utils.js";
import { colors } from "../components/common/mixins.js"

const ViewLess = styled.div`
  color: ${colors.primary};
  margin-top: 16px;
`;

const ViewMore = styled.div`
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: var(--linkDecoration);
  color: ${colors.primary};
  z-index: 10;
`;

const DescriptionText = ({ content, widthProp, isEventPage }) => {
  const [expanded, setExpanded] = useState(false);
  const [showButtons, setShowButtons] = useState(false);
  const textRef = useRef(null);

  const toggleViewMore = (e) => {
    e.preventDefault();
    setExpanded((prevState) => !prevState);
    if (expanded) {
      Utils.smoothScroll(document.querySelector(".r_descriptionText"));
    }
  };

  const checkOverflow = () => {
    const contentDiv = textRef.current;
    if (contentDiv) {
      const contentHeight = contentDiv.scrollHeight;
      const divHeight = 528;
      const showButtonsVal = contentHeight > divHeight;
      setShowButtons(showButtonsVal);
    }
  };

  useEffect(() => {
    checkOverflow();
  }, []);

  const contentStyle = {
    maxHeight: "none",
    maxWidth: widthProp,
  };

  const withGradientStyle = {
    maxHeight: isEventPage ? "569px" : "434px",
    overflow: "hidden",
    maxWidth: widthProp,
    position: "relative",
  };

  return (
    <>
      {showButtons ? (
        <div className="r_descriptionText">
          {expanded ? (
            <>
              <div
                style={contentStyle}
                className="r_descriptionExpanded"
                ref={textRef}
                dangerouslySetInnerHTML={{ __html: content }}
              />
              <ViewMore onClick={toggleViewMore}>
                <ViewLess>
                  {playdetailsv2_resources.ViewLess}
                </ViewLess>
              </ViewMore>
            </>
          ) : (
            <>
              <div
                style={withGradientStyle}
                className="r_descriptionWithGradient"
                ref={textRef}
                dangerouslySetInnerHTML={{ __html: content }}
              />
              <ViewMore onClick={toggleViewMore}>
                <span>{playdetailsv2_resources.ViewMore}</span>
              </ViewMore>
            </>
          )}
        </div>
      ) : (
        <div
          className="r_descriptionText"
          style={{ maxWidth: widthProp }}
          ref={textRef}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
    </>
  );
};

export default DescriptionText;
